//import DailyReportDataFunc from "@/pcomponents/common/content/edu/daily_report/func/data_func";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import TodoStateFunc from "@/pcomponents/common/content/todo/state/func/state_func";
import strFunc from "@/lib/lyg/string";

class DailyReportDataFunc {
  static default_daily_info = {
    a_ymd: "",
    a_seq: "",
    a_date: "",
    a_lecture_time: "",
    a_stu_seq: "",
    a_stu_name: "",
    a_homework: "",
    a_textbook: "",
    a_textbook_seq: "",
    a_textbook_study: "",
    a_textbook_study_det: "",
    a_subtextbook: "",
    a_subtextbook_seq: "",
    a_subtextbook_study: "",
    a_subtextbook_study_det: "",
    a_memo: "",
    a_textbook_study_num: "0",
    a_textbook_study_det_num: "0",
    a_todo_sub_success_amount: "0",
    a_todo_sub_amount: "0",
    a_todo_success_amount: "0",
    a_todo_amount: "0",
    a_homework_state: "",
    a_study_state: "",
    a_study_amount_memo: "",
  };
  static get_show_info_arr(inData: any) {
    let opt_obj = {
      infoArr: [],
      ...inData
    };
    let infoArr = opt_obj.infoArr;
    let select_stu_grade_arr = XcolumnFunc.getSortByTableKey({ 'table': 'user', 'key': 'a_stu_grade2' });
    let select_homework_state_arr = XcolumnFunc.getSortByTableKey({ 'table': 'daily_report', 'key': 'a_homework_state' });
    let this_obj = this;

    let show_info_arr: any = [];
    for (let i = 0; i < infoArr.length; i++) {
      let info = infoArr[i];
      let show_row: any = {};
      for (let key in info) {
        let val = "";
        if (info[key]) {
          val = info[key];
        }
        val = this_obj.get_show_val_of_daily_info({
          info: info,
          key: key,
          val: val,
          select_stu_grade_arr: select_stu_grade_arr,
          select_homework_state_arr: select_homework_state_arr
        });

        show_row[key] = val;
      }
      show_info_arr.push(show_row);
    }
    return show_info_arr;
  };
  static get_show_val_of_daily_info(inData: any) {
    let opt_obj = {
      info: {},
      key: "",
      val: "",
      select_stu_grade_arr: [],
      select_homework_state_arr: [],
      ...inData
    };
    let info = opt_obj.info;
    let key = opt_obj.key;
    let val = opt_obj.val;
    let select_stu_grade_arr = opt_obj.select_stu_grade_arr;
    let select_homework_state_arr = opt_obj.select_homework_state_arr;

    if (key == "a_stu_name") {
      if (info.stu_info) {
        let tmp_stu_grade = "";
        for (let i = 0; i < select_stu_grade_arr.length; i++) {
          if (select_stu_grade_arr[i]["value"] == info.stu_info["a_stu_grade"]) {
            tmp_stu_grade = select_stu_grade_arr[i]["text"];
          }
        }
        val = val + " " + tmp_stu_grade;
      }
    } else if (key == "a_homework_state" || key == "a_study_state") {
      for (let i = 0; i < select_homework_state_arr.length; i++) {
        if (select_homework_state_arr[i]["value"] == info[key]) {
          val = select_homework_state_arr[i]["text"];
          break;
        }
      }
    } else if (key == "a_textbook_study") {
      if (info["a_textbook_study_num"]) {
        val = info["a_textbook_study_num"] + ". " + val;
      }
    } else if (key == "a_textbook_study_det") {
      if (info["a_textbook_study_det_num"]) {
        val = info["a_textbook_study_det_num"] + ". " + val;
      }
    }

    return val;
  }
  static get_homework_per_by_state_str(inData: any) {
    let opt_obj = {
      state_str: "",
      ...inData
    };
    let state_str = opt_obj.state_str;
    let homework_per: any = 0;
    if (state_str == "1") {
      homework_per = 100;
    } else if (state_str == "2") {
      homework_per = 0;
    } else if (state_str == "3") {
      homework_per = 50;
    } else if (state_str == "4") {
      homework_per = "";
    }
    return homework_per;
  };
  static get_show_plain_text_by_info(inData: any) {
    let opt_obj = {
      info: null,
      is_stu_name: true,
      is_time: true,
      is_amount_memo: false,
      is_memo: true,
      ...inData
    };
    let info = opt_obj.info;
    let show_info_arr = this.get_show_info_arr({ infoArr: [info] });
    let show_info = show_info_arr[0];
    //없음 없애기
    for (let key in show_info) {
      if (show_info[key] == "없음") {
        show_info[key] = "";
      }
    }
    let home_work_percent = this.get_homework_per_by_state_str({ state_str: info["a_homework_state"] });
    let show_plain_text: any = "";
    let line_break = "\n";

    if (opt_obj.is_stu_name) {
      show_plain_text += info["a_stu_name"] + " 학생 " + show_info["a_lecture_name"];
      if (opt_obj.is_time) {
        show_plain_text += " " + show_info["a_lecture_time"];
      }
      show_plain_text += line_break;
    }

    show_plain_text += "<" + show_info["a_subject"] + ">";
    if (home_work_percent !== "") {
      show_plain_text += " 숙제(" + home_work_percent + "%) ";
    }
    show_plain_text += " " + show_info["a_homework"];
    if (show_info["a_textbook"]) {
      show_plain_text += line_break;
      show_plain_text += show_info["a_textbook"] + " / " + show_info["a_textbook_study"];
      if (show_info["a_subtextbook"]) {
        show_plain_text += " / " + show_info["a_subtextbook"];
      }
    }
    if (opt_obj.is_amount_memo) {
      if (show_info["a_study_amount_memo"]) {
        show_plain_text += line_break;
        show_plain_text += show_info["a_study_amount_memo"];
      }
    }
    if (opt_obj.is_memo) {
      if (show_info["a_memo"]) {
        show_plain_text += line_break;
        show_plain_text += "(memo)" + show_info["a_memo"];
      }
    }

    return show_plain_text;
  }
  static get_show_plain_text_by_info_arr(inData: any) {
    let opt_obj = {
      infoArr: [],
      ...inData
    };
    let infoArr = opt_obj.infoArr;
    let show_plain_text_arr = [];
    let this_obj = this;
    for (let i = 0; i < infoArr.length; i++) {
      let info = infoArr[i];
      let show_plain_text = this_obj.get_show_plain_text_by_info({ info: info });
      show_plain_text_arr.push(show_plain_text);
    }
    return show_plain_text_arr;
  }
  static get_last_daily_info_by_lecture(inData: any) {
    let opt_obj = {
      stu_info: null,
      lecture_info: null,
      last_daily_report_arr: [],
      subject: "",
      ...inData
    };
    let stu_info = opt_obj.stu_info;
    let lecture_info = opt_obj.lecture_info;
    let last_daily_report_arr = opt_obj.last_daily_report_arr;
    let subject = opt_obj.subject;
    let last_daily_info: any = {};
    if (last_daily_report_arr && last_daily_report_arr.length > 0 && lecture_info != null) {
      for (let i = 0; i < last_daily_report_arr.length; i++) {
        let row_daily_info = last_daily_report_arr[i];
        if (row_daily_info["a_stu_seq"] == stu_info["a_seq"]
          // && row_daily_info["a_writer_seq"] == lecture_info["a_main_teacher_seq"]
          && row_daily_info["a_lecture_seq"] == lecture_info["a_seq"]
          // && row_daily_info["a_subject"] == lecture_info["a_subject"]
        ) {
          //last_daily_info = row_daily_info;
        }
      }
    }
    if (last_daily_info["a_stu_seq"] == undefined) {
      if (last_daily_report_arr && last_daily_report_arr.length > 0 && lecture_info != null) {
        for (let i = 0; i < last_daily_report_arr.length; i++) {
          let row_daily_info = last_daily_report_arr[i];
          if (row_daily_info["a_stu_seq"] == stu_info["a_seq"]
            // && row_daily_info["a_writer_seq"] == lecture_info["a_main_teacher_seq"]
            // && row_daily_info["a_lecture_seq"] == lecture_info["a_seq"]
            && row_daily_info["a_subject"] == lecture_info["a_subject"]
          ) {
            last_daily_info = row_daily_info;
            break;
          }
        }
      }
    }
    if (last_daily_info["a_stu_seq"] == undefined) {
      if (last_daily_report_arr && last_daily_report_arr.length > 0 && subject) {
        for (let i = 0; i < last_daily_report_arr.length; i++) {
          let row_daily_info = last_daily_report_arr[i];
          if (row_daily_info["a_stu_seq"] == stu_info["a_seq"]
            && row_daily_info["a_subject"] == subject
          ) {
            last_daily_info = row_daily_info;
            break;
          }
        }
      }
    }
    return last_daily_info;
  }

  static get_daily_info_of_date(inData: any) {
    let opt_obj = {
      date_str: "",
      pre_date_str: "",
      is_now_date: false,
      last_daily_info: {},
      lecture_time_str: "",
      info: {},
      lecture_info: null,
      user: null,
      writer_seq: "",
      writer_name: "",
      subject: "",
      ...inData,
    };
    let lecture_info = opt_obj["lecture_info"];
    let info = opt_obj["info"];
    let user = opt_obj["user"];
    let this_obj = this;
    let daily_info: any = {
      ...this_obj.default_daily_info,
      ...opt_obj.last_daily_info,
      a_ymd: strFunc.getNumber2(opt_obj["date_str"]),
      a_seq: "",
      a_date: opt_obj["date_str"],
      a_lecture_time: opt_obj.lecture_time_str,
      a_stu_seq: info["a_seq"],
      a_stu_name: info["a_user_name"],
      a_todo_sub_success_amount: "0",
      a_todo_sub_amount: "0",
      a_todo_success_amount: "0",
      a_todo_amount: "0",
      a_study_state: "",
      a_memo: "",
      a_prescribe_req_memo: "",
      a_subject: opt_obj.subject,
    };
    if (daily_info.a_homework_state != "4") {
      daily_info.a_homework_state = "";
    }
    if (lecture_info != null) {
      daily_info["a_subject"] = lecture_info["a_subject"];
    }

    //기존데이터 덮어쓰기
    if (info.daily_report_arr && info.daily_report_arr.length > 0 && lecture_info != null) {
      for (let i = 0; i < info.daily_report_arr.length; i++) {
        let row_daily_info = info.daily_report_arr[i];
        if (row_daily_info["a_lecture_seq"] == lecture_info["a_seq"]
          && row_daily_info["a_stu_seq"] == info["a_seq"]
          //&& row_daily_info["a_writer_seq"] == lecture_info["a_main_teacher_seq"]
          && row_daily_info["a_date"] == opt_obj["date_str"]
          && row_daily_info["a_lecture_time"] == opt_obj.lecture_time_str) {
          daily_info = {
            ...daily_info,
            ...row_daily_info
          };
        }
      }
    }
    if (strFunc.is_empty(daily_info.a_seq)) {
      if (info.daily_report_arr && info.daily_report_arr.length > 0) {
        for (let i = 0; i < info.daily_report_arr.length; i++) {
          let row_daily_info = info.daily_report_arr[i];
          if (row_daily_info["a_stu_seq"] == info["a_seq"]
            && row_daily_info["a_date"] == opt_obj["date_str"]
            && row_daily_info["a_lecture_time"] == opt_obj.lecture_time_str
            && row_daily_info["a_subject"] == daily_info["a_subject"]) {
            daily_info = {
              ...daily_info,
              ...row_daily_info
            };
          }
        }
      }
    }
    if (lecture_info != null) {
      daily_info["a_lecture_seq"] = lecture_info["a_seq"];
      daily_info["a_lecture_name"] = lecture_info["a_name"];
      daily_info["a_writer_seq"] = lecture_info["a_main_teacher_seq"];
      daily_info["a_writer"] = lecture_info["a_main_teacher"];
      daily_info["a_subject"] = lecture_info["a_subject"];
    }
    if (strFunc.is_empty(daily_info["a_writer_seq"])) {
      daily_info["a_writer_seq"] = opt_obj["writer_seq"];
      daily_info["a_writer"] = opt_obj["writer_name"];
    }
    if (strFunc.is_empty(daily_info["a_writer_seq"]) && user) {
      daily_info["a_writer_seq"] = user.user_seq;
      daily_info["a_writer"] = user.user_name;
    }

    //오늘꺼 덮어쓰기
    if (opt_obj["is_now_date"]) {
      if (info.td_sort_data_json && info.td_sort_data_json["pre_homework"]) {
        daily_info["a_homework_per_num"] = info.td_sort_data_json["pre_homework"]["percent"];
      }

      let home_work_file_cnt = TodoStateFunc.get_file_cnt_by_user_info({
        info: info,
        date_sort: "pre",//pre,now
        select_date: opt_obj["date_str"],
        pre_date_str: opt_obj["pre_date_str"],
        file_sort: "homework"
      });
      daily_info["a_homework_file_cnt"] = home_work_file_cnt;
    }

    return daily_info;
  };
}
export default DailyReportDataFunc;